import {startAuthentication,startRegistration,browserSupportsWebAuthn,type PublicKeyCredentialCreationOptionsJSON,type PublicKeyCredentialRequestOptionsJSON} from '@simplewebauthn/browser';
import {api,apiPost} from '@/lib/api';
import type {AuthSession} from './api';
export {browserSupportsWebAuthn};
export async function signInWithPasskey():Promise<AuthSession> {
  const ceremony=await api<{options:PublicKeyCredentialRequestOptionsJSON;challenge_token:string}>('/v1/auth/passkeys/options',{anonymous:true,method:'POST',body:'{}'});
  const response=await startAuthentication({optionsJSON:ceremony.options});
  return api<AuthSession>('/v1/auth/passkeys/verify',{anonymous:true,method:'POST',body:JSON.stringify({challenge_token:ceremony.challenge_token,response})});
}
const VERIFIER_KEY='ailechat:desktop-passkey-verifier';
export const DESKTOP_PASSKEY_PARAM='desktop_passkey';
async function sha256Hex(value:string):Promise<string> {
  const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(value));
  return Array.from(new Uint8Array(digest),byte=>byte.toString(16).padStart(2,'0')).join('');
}
/** Desktop app: start a passkey sign-in in the system browser and return the URL to open. */
export async function startDesktopPasskey(origin:string=window.location.origin):Promise<string> {
  const verifier=Array.from(crypto.getRandomValues(new Uint8Array(32)),byte=>byte.toString(16).padStart(2,'0')).join('');
  window.localStorage.setItem(VERIFIER_KEY,verifier);
  return `${origin}/login?${DESKTOP_PASSKEY_PARAM}=${await sha256Hex(verifier)}`;
}
/** Desktop app: redeem the one-time code the browser handed back through ailechat://auth-callback. */
export async function finishDesktopPasskey(code:string):Promise<AuthSession> {
  const verifier=window.localStorage.getItem(VERIFIER_KEY);
  if(!verifier)throw new Error('Passkeyのログインをもう一度アプリから始めてください。');
  const session=await api<AuthSession>('/v1/auth/passkeys/desktop/exchange',{anonymous:true,method:'POST',body:JSON.stringify({code,verifier})});
  window.localStorage.removeItem(VERIFIER_KEY);
  return session;
}
/** System browser: verify the passkey and return the app callback URL carrying a one-time code. */
export async function handoffPasskeyToDesktop(verifierHash:string):Promise<string> {
  const ceremony=await api<{options:PublicKeyCredentialRequestOptionsJSON;challenge_token:string}>('/v1/auth/passkeys/options',{anonymous:true,method:'POST',body:'{}'});
  const response=await startAuthentication({optionsJSON:ceremony.options});
  const {code}=await api<{code:string}>('/v1/auth/passkeys/desktop/handoff',{anonymous:true,method:'POST',body:JSON.stringify({challenge_token:ceremony.challenge_token,response,verifier_hash:verifierHash})});
  return `ailechat://auth-callback?code=${encodeURIComponent(code)}`;
}
export async function registerPasskey(name:string):Promise<void> {
  const ceremony=await apiPost<{options:PublicKeyCredentialCreationOptionsJSON;challenge_token:string}>('/v1/me/passkeys/options',{});
  const response=await startRegistration({optionsJSON:ceremony.options});
  await apiPost('/v1/me/passkeys/verify',{challenge_token:ceremony.challenge_token,response,name});
}
export function passkeyError(error:unknown):string {
  if(error instanceof Error||(typeof DOMException!=='undefined'&&error instanceof DOMException)){
    if(error.name==='NotAllowedError')return 'Passkeyの確認がキャンセルされたか、時間切れになりました。もう一度お試しください。';
    if(error.name==='InvalidStateError')return 'このPasskeyは登録済みです。別の端末や認証器を選んでください。';
    return error.message;
  }
  return 'Passkeyを確認できませんでした。もう一度お試しください。';
}
